import { getAppMaster, getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { table, viewId } from '../../../../_constants/Code'

const getSession = (store) => {
  const state = store.getState()

  return {
    corporationNumber: state.company.corporationNumber
  }
}

/**
 * マスター情報をDynamoDBから取得する関数
 *
 * @async
 * @param {string} corporationNumber - 法人番号
 * @returns {Promise<Object | null>} マスター情報の最初の要素、存在しない場合はnull
 */
export async function fetchMaster(corporationNumber) {
  const master = await getDynamoDB(
    table.Master,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber, MasterId: viewId.chrofyClassificationInfo },
    null
  )
  return master[0]
}

/**
 * 区分一覧を取得する（AppMasterテーブルから）
 *
 * @param {any} store - Redux store
 * @returns {Promise<{ key: string; label: string; displayOrder: number; memo: string }[]>}
 */
export const fetchChrofyClassificationType = async (store) => {
  try {
    const { corporationNumber } = getSession(store)

    const data = await getAppMaster(
      corporationNumber,
      { ConfigName: 'ChrofyClassification' }, // PKをkeyとして指定
      null // optionsは不要
    )

    if (!data || !Array.isArray(data)) {
      return []
    }

    // DynamoDBデータを画面データ形式に変換
    const types = data
      .map((item) => {
        const key = item.ChrofyClassificationKey ?? item.chrofyClassificationKey ?? ''
        const label = item.ChrofyClassificationName ?? item.chrofyClassificationName ?? ''
        const displayOrder = item.ChrofyClassificationDisplayOrder ?? item.chrofyClassificationDisplayOrder ?? 0
        const memo = item.ChrofyClassificationDescription ?? item.chrofyClassificationDescription ?? ''

        if (!key || !label) {
          return null
        }

        return {
          code: key,
          label: label,
          displayOrder: Number(displayOrder) || 0,
          memo: memo
        }
      })
      .filter(Boolean)
      .sort((a, b) => a.displayOrder - b.displayOrder)

    return types
  } catch (error) {
    console.error('区分一覧取得エラー:', error)
    throw error
  }
}

/**
 * 全区分の項目を取得する（AppMasterテーブルから）
 *
 * @param {any} store - Redux store
 * @param {{ code: string }[]} types - 区分一覧（互換性のため残すが使用しない）
 * @returns {Promise<{ key: string; classificationKey: string; code: string; value: string; displayOrder: number }[]>}
 */
export const fetchChrofyClassificationRecords = async (store, types) => {
  try {
    const { corporationNumber } = getSession(store)

    // ConfigNameのみで全区分項目を一度に取得
    const data = await getAppMaster(
      corporationNumber,
      { ConfigName: 'ChrofyClassificationItem' }, // PKをkeyとして指定
      null // SearchKeyは指定しない（全件取得）
    )

    if (!data || !Array.isArray(data)) {
      return []
    }

    // DynamoDBデータを画面データ形式に変換
    const items = data
      .map((item) => {
        const key = item.ChrofyClassificationItemKey ?? item.chrofyClassificationItemKey ?? ''
        const classificationKey = item.ChrofyClassificationKey ?? item.chrofyClassificationKey ?? ''
        const code = item.ChrofyClassificationItemCode ?? item.chrofyClassificationItemCode ?? ''
        const value = item.ChrofyClassificationItemValue ?? item.chrofyClassificationItemValue ?? ''
        const displayOrder = item.ChrofyClassificationItemDisplayOrder ?? item.chrofyClassificationItemDisplayOrder ?? 0

        if (!key) {
          return null
        }

        return {
          key: key,
          classificationKey: classificationKey,
          code: code,
          value: value,
          displayOrder: Number(displayOrder) || 0
        }
      })
      .filter(Boolean)
      .sort((a, b) => a.displayOrder - b.displayOrder)

    return items
  } catch (error) {
    console.error('区分項目取得エラー:', error)
    throw error
  }
}
